import { Capacitor } from '@capacitor/core'

let lastHapticAt = 0

export const haptic = async (
  type: 'soft' | 'medium' | 'success' | 'selection' = 'soft',
) => {
  if (!Capacitor.isNativePlatform()) return
  const now = performance.now()
  if (now - lastHapticAt < 72) return
  lastHapticAt = now
  try {
    const { Haptics, ImpactStyle, NotificationType } =
      await import('@capacitor/haptics')
    if (type === 'success') {
      await Haptics.notification({ type: NotificationType.Success })
    } else if (type === 'selection') {
      await Haptics.selectionStart()
      await Haptics.selectionChanged()
      await Haptics.selectionEnd()
    } else {
      await Haptics.impact({
        style: type === 'medium' ? ImpactStyle.Medium : ImpactStyle.Light,
      })
    }
  } catch {
    // Native feedback is progressive enhancement.
  }
}

export const shareContent = async ({
  title,
  text,
  url,
}: {
  title?: string
  text?: string
  url: string
}) => {
  const payload = {
    url,
    ...(title ? { title } : {}),
    ...(text ? { text } : {}),
  }
  if (Capacitor.isNativePlatform()) {
    const { Share } = await import('@capacitor/share')
    await Share.share({ ...payload, dialogTitle: 'Voxnela’da paylaş' })
    return
  }

  if (navigator.share) {
    await navigator.share(payload)
    return
  }

  await navigator.clipboard.writeText(url)
}
